<template>
<div class="row input-upload">
    <div class="col-7">
        <el-upload action="" drag :auto-upload="false" :file-list="fileList" :on-change="handleChange" :limit="10" :show-file-list="false" accept=".jpg, .png" ref="upload">
            <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="24" cy="24" r="24" fill="#F4F7FB" />
                <path d="M28.8006 24.8516V26.9848C28.8006 27.2677 28.6882 27.539 28.4882 27.739C28.2881 27.939 28.0168 28.0514 27.7339 28.0514H20.2669C19.984 28.0514 19.7127 27.939 19.5126 27.739C19.3126 27.539 19.2002 27.2677 19.2002 26.9848V24.8516" stroke="#727D94" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M26.6675 21.1177L24.0008 18.4512L21.334 21.1177" stroke="#727D94" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M24.001 18.4512V24.8508" stroke="#727D94" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
            </svg>

            <p class="medium c-ndarkthree">Arraste e solte aqui ou <span :class="`c-${getPrimaryColor}five underline`">procure do seu computador.</span></p>
            <h6 slot="tip" class="c-nmidone regular">
                Formatos aceitos: .jpeg e .png. <br> Tamanho máximo: 1 MB.
            </h6>
        </el-upload>
    </div>
    <div class="col-12">
        <div v-if="savedLogo.length && !previewBackupImage" class="mt-4 mb-3 d-flex align-items-center">
            <div class="card-logo mr-4">
                <el-image style="width: 130px; height: 70px" :src="logoPath" fit="contain"/>
            </div>
            <div class="row">
                <div class="col-8 mb-2 break-col">
                    <p class="underline break">{{ logoName }}</p>
                </div>
                <div class="col-12">
                    <Button @click="replaceFile" class="mr-3" type="outline" color="grey" size="small"><Replace /> Substituir </Button>
                    <Button @click="removeFile" size="small" type="outline" color="red"><Delete size="10"/> Excluir </Button>
                </div>
            </div>
        </div>
        <div v-else-if="file.name" class="mt-4 mb-3 d-flex align-items-center">
            <div class="card-logo mr-4">
                <el-image style="width: 130px; height: 70px" :src="filePath" fit="contain"/>
            </div>
            <div class="row">
                <div class="col-8 mb-2 break-col">
                    <p class="underline break">{{ file.name }}</p>
                </div>
                <div class="col-12">
                    <Button @click="replaceFile" class="mr-3" type="outline" color="grey" size="small"><Replace /> Substituir </Button>
                    <Button @click="removeFile" size="small" type="outline" color="red"><Delete size="10"/> Excluir </Button>
                </div>
            </div>
        </div>
        <div v-else-if="previewBackupImage" class="mt-4 mb-3 d-flex align-items-center">
            <div class="card-logo mr-4">
                <el-image style="width: 130px; height: 70px" :src="filePreviewPath" fit="contain"/>
            </div>
            <div class="row">
                <div class="col-8 mb-2 break-col">
                    <p class="underline break">{{ previewBackupImage.name }}</p>
                </div>
                <div class="col-12">
                    <Button @click="replaceFile" class="mr-3" type="outline" color="grey" size="small"><Replace /> Substituir </Button>
                    <Button @click="removeFile" size="small" type="outline" color="red"><Delete size="10"/> Excluir </Button>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import Replace from '@/components/icons/Replace'
import Delete from '@/components/icons/Delete'
export default {
    props: {
        logo: {
            default: ''
        },
        previewBackupImage: {
            default: ''
        }
    },
    components: {
        Replace,
        Delete,
    },
    data() {
        return {
            fileList: [],
            file: {},
            savedLogo: ''
        };
    },
    methods: {
        removeFile() {
            this.file = {}
            this.savedLogo = ''
            this.$emit('delete', '')
        },
        previewFile(file) {
            var fileURL = URL.createObjectURL(file.raw);
            window.open(fileURL);
        },
        toBase64: file => new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => resolve(reader.result);
            reader.onerror = error => reject(error);
        }),
        async handleChange(file) {
            this.file = file
            this.savedLogo = ''
            const base64File = await this.toBase64(file.raw)
            const base64Header = base64File.indexOf(',') + 1
            const fileData = {
                name: file.name,
                file: base64File.slice(base64Header , base64File.length)
            }
            this.$emit('change', fileData)
            this.$store.commit('register/setCompany', { filePreview: file } )
        },
        replaceFile() {
            document.querySelector('.el-upload__input').click()
        }
    },
    computed: {
        filePath() {
            if (this.file.raw) {
                return URL.createObjectURL(this.file.raw)
            } else {
                return ''
            }
        },
        filePreviewPath() {
            if (this.previewBackupImage.raw) {
                return URL.createObjectURL(this.previewBackupImage.raw)
            } else {
                return ''
            }
        },
        logoPath() {
            if (this.savedLogo.length) return `${process.env.VUE_APP_ROOT_API}/${this.savedLogo}`
            return ''
        },
        logoName() {
            if (this.savedLogo.length) {
                const logoPathSplited =  this.savedLogo.split('/')
                return logoPathSplited[logoPathSplited.length - 1]
            }
            return ''
        }
    },
    created() {
        if (this.logo) {
            this.savedLogo = this.logo
        } else {
            this.savedLogo = ''
        }
    }
};
</script>